import type { ReactNode } from 'react'

import { Camera01Icon, GridViewIcon, StarIcon } from '@hugeicons/react'

import type { FilterChipOption } from '@/shared/ui/Layout/page/FilterChips'

import { FEED_FILTERS } from '../model/filtering'

/* Mesmo padrão de journeyFilterOptions/missionFilterOptions: ícone neutro em
   "todos", cor de marca no que sinaliza destaque. "fotos" é tipo de conteúdo,
   não status, por isso fica neutro como "todos". */
const FEED_FILTER_ICONS: Record<string, ReactNode> = {
  todos: <GridViewIcon size={12} variant="stroke" aria-hidden />,
  destaques: (
    <StarIcon size={12} variant="duotone" style={{ color: 'var(--color-brand)' }} aria-hidden />
  ),
  fotos: <Camera01Icon size={12} variant="stroke" aria-hidden />
}

export const FEED_FILTER_OPTIONS: FilterChipOption[] = FEED_FILTERS.map(filter => ({
  ...filter,
  icon: FEED_FILTER_ICONS[filter.id]
}))
